import React, { Fragment, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import VoucherService from "../../Api/services/VoucherService";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const Thankyouvoucher = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const handleOnUnload = () => {
      localStorage.removeItem("payment_status_voucher")
    };
    window.addEventListener("unload", handleOnUnload);
    return () => {
      window.removeEventListener("unload", handleOnUnload);
    };
  }, []);

  useEffect(() => {
    async function trackVoucherPurchase() {
      const getId = searchParams.get("id"); // stripe session id (existing)
      const pushOnce = (payload) => {
        const transactionId = String(payload.transaction_id || payload.order_id || "");
        if (!transactionId) return;

        const storageKey = `tracked_voucher_${transactionId}`;
        if (window[`_tracked_voucher_${transactionId}`] || localStorage.getItem(storageKey)) return;
        window[`_tracked_voucher_${transactionId}`] = true;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "purchase_giftcard",
          transaction_id: String(transactionId),
          value: Number(payload.total_price || payload.amount || 0),
          currency: "EUR",
          product_type: "giftcard",
          payment_type: String(payload.payment_type || "cash"),
          giftcard_value: Number(payload.giftcard_value || payload.total_price || payload.amount || 0),

          // Consistency fields (empty for giftcard but kept for schema alignment)
          camper_model: "",
          start_date: "",
          end_date: ""
        });

        localStorage.setItem(storageKey, "true");
      };

      // 1) STRIPE flow (existing)
      if (getId) {
        const p_service = await VoucherService.checkstripepayment(getId).json();

        if (p_service?.status == true) {
          pushOnce({
            transaction_id: p_service.order_id || getId,
            amount: p_service.amount || 0,
            giftcard_value: p_service.amount || 0,
            payment_type: "stripe",
            email: p_service.email || "",
          });
        }
        return;
      }

      // 2) CASH / PAYPAL flow (state first)
      let order_id = location?.state?.order_id;
      if (order_id) {
        localStorage.setItem("last_thankyou_voucher_order", String(order_id));
      } else {
        order_id = localStorage.getItem("last_thankyou_voucher_order");
      }
      if (!order_id) return;

      // read saved payload
      const saved = localStorage.getItem(`thankyou_voucher_track_${order_id}`);
      if (!saved) return;

      const data = JSON.parse(saved);
      pushOnce({
        transaction_id: data.order_id,
        amount: data.total_price || 0,
        giftcard_value: data.giftcard_value || data.total_price || 0,
        payment_type: data.payment_type || "cash",
        email: data.email || "",
      });
    }

    trackVoucherPurchase();

    localStorage.removeItem("payment_status_voucher");
    localStorage.removeItem("stripesessionvoucher");
    Cookies.set("Token", "value", { expires: 7 });
  }, [searchParams, location?.state]);

  return (
    <Fragment>
      <Header />
      <div className="min-h-screen bg-off-white">
        <div className="pb-5 text-center">
          <div className="overflow-hidden">
            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
              <div className="relative">
                <div className="overflow-hidden">
                  <img
                    src="../Images/Thank you pages.jpg"
                    alt="hero-banner"
                    className="absolute max-h-full w-full scale-110 object-cover blur-lg dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                  />
                </div>
                <picture className="flex max-h-[65vh] w-full text-0">
                  <img
                    className="z-0 max-h-full w-full object-cover dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                    src="../Images/Thank you pages.jpg"
                    alt="hero-banner"
                    width="2552"
                    height="1286"
                  />
                </picture>
                <div className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-end">
                  <div className="pb-12 2xl:pb-14 w-full bg-gradient-to-t from-black-pure/80 to-transparent pt-20 md:pt-14 xl:pt-32">
                    <h1 className="whitespace-pre-line break-words m-auto max-w-4xl px-8 text-xl md:text-2xl text-white drop-shadow-text dark:text-off-white xs:text-2xl xl:text-3xl mb-5 md:mb-8 xl:mb-12">
                      {t("thankyou.Thank You")}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-5 max-w-screen-xl xl-padded:mx-auto">
          <div className="xl:pt-8 pt-3 2xl:pt-8 pb-8 2xl:pb-12 mx-auto flex max-w-4xl flex-col items-center text-center">
            <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark mb-4 child:h-20 child:w-20">
              <img src="../Images/img-aboutus-header-banner.svg" alt="aboutus-header-banner" />
            </div>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-4">
              {t("thankyou.Thank you for your trust!")}
            </h2>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("thankyou.Within the next 48 hours, you'll receive an email containing your voucher.")}
            </p>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("thankyou.If you have any questions before then, don't hesitate to contact us!")}
            </p>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              WhatsApp: +49 163 2937354
            </p>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("thankyou.Go To")}<Link className="w-full text-center hover:text-primary hover:dark:text-primary-light mb-2 last:mb-0" to={'/'}> {t("thankyou.Home")}</Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Thankyouvoucher;